import React from 'react'
import { Form, Skeleton, Input } from 'antd'
import { UserOutlined } from '@ant-design/icons'

export default function InputField (props) {
    if (props.isLoading) {
        return <Skeleton.Input style={{marginBottom:"16px"}} active="false" size={props.size} />
    }

    return (
        <Form.Item style={{marginBottom:"8px"}}
            label={props.label}
            name={props.input}
            rules={[{ required: props.isRequired, message: props.isRequiredText }]}
        >
            <Input 
                name={props.input} 
                disabled={props.disabled}
                prefix={<UserOutlined />}
            />       
        </Form.Item>
    )
}